import { ApiError } from "@altek/ui/lib/problem";
import { toast } from "@altek/ui/lib/utils/toast";
import { apiErrorMessage } from "@/lib/api/error-messages";

/**
 * BİR İŞLEMİN HATASI, TEK BİLDİRİMDE — doğru cümle, «Destek kodu» YALNIZ 5xx'TE (9 Ekim 2026,
 * 4. tur; yönetim ve pazarlama ayrı ayrı yazmıştı, burada birleşti).
 *
 * Üç yanlış yazım vardı ve üçü de «çalışıyor» görünüyordu:
 *   - `toast.error(messageFor(error))` / `toast.error("cümle")`: kitin `toast.error`'u bir HATA
 *     NESNESİ bekliyor; dize verilince açıklama hep «Beklenmeyen bir hata oluştu.» oluyordu.
 *   - `toast.error(error)`: her `ApiError`'da `requestId`'yi «Destek kodu» olarak basıyor (kitin
 *     kendi notu «kişiye yalnız 5xx'te gösterilir» diyor; kit isteği). 409 «kayıt kullanımda»
 *     gibi kişinin kendisinin çözeceği bir cevabın altında kod görünce kişi arıza sanıyordu.
 *     Doğrulama hatasında da SESSİZ — alanı olmayan bir eylemde ret hiçbir yerde görünmüyordu.
 *   - `toast.errorMessage(başlık, apiErrorMessage(error))`: cümle doğru ama 5xx'te kod yok.
 *
 * Kural: 4xx (doğrulama dahil) uygulamanın sade cümlesiyle (`apiErrorMessage`, kitinkine düşer);
 * sunucu arızası, ağ ve beklenmeyen hata kitin yolundan, destek koduyla. Kaldırılan istek
 * (`AbortError` — yeniden kimlik doğrulamadan vazgeçmek gibi) bildirim değil.
 *
 * ARGÜMAN SIRASI kitinkiyle aynı: önce hata, sonra başlık (`toast.error(error, başlık)`). Kit 4xx'te
 * kodu basmayı bırakınca bu işlev `toast.error`'a iner.
 */
export function toastFailure(error: unknown, title = "İşlem tamamlanamadı"): void {
  if (error instanceof DOMException && error.name === "AbortError") return;
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
    toast.errorMessage(title, apiErrorMessage(error));
    return;
  }
  toast.error(error, title);
}
